export const CURRENCY_SYMBOL_BY_CODE = {
  aud: '$',
  cad: '$',
  usd: '$',
  eur: '€',
  gbp: '£'
}